import { render } from "./MPoppup.vue?vue&type=template&id=e982525c&scoped=true"
import script from "./MPoppup.vue?vue&type=script&lang=js"
export * from "./MPoppup.vue?vue&type=script&lang=js"

import "./MPoppup.vue?vue&type=style&index=0&id=e982525c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e982525c"]])

export default __exports__